import { ChangePasswordController } from './change-password.controller';
import { IComponentOptions } from 'angular';

export const CHANGE_PASSWORD_COMPONENT = "changePasswordComponent";
export const changePasswordComponentOptions: IComponentOptions = {
    controller: ChangePasswordController,
    template: require("./change-password.html"),
    bindings: {
        email: "<"
    }
};


// WEBPACK FOOTER //
// ./app/change-password/change-password.component.ts